export enum KnownErrorTag {
    ReconciliationEmployee = "56.1",
}

export const isKnownErrorTag = (tag: string): tag is KnownErrorTag =>
    Object.values(KnownErrorTag as Record<string, string>).includes(tag);
